var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{staticStyle:{"max-width":"280px"},attrs:{"inline":_vm.inline,"model":( _obj = {}, _obj[_vm.field] = _vm.newValue, _obj ),"rules":_vm.rules,"show-message":false,"onsubmit":"return false"}},[_c('el-form-item',{style:({
      'margin-bottom': _vm.inline ? '0' : '8px'
    }),attrs:{"prop":_vm.field}},[_vm._t("default")],2),_c('el-form-item',{staticStyle:{"margin-bottom":"0px"}},[_vm._t("action")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }